import { APPLICANT_CONTENT } from '@/features/applicant/constants/applicantContent'
import type { PaymentFormGuard } from './paymentFormTypes'

export function PaymentFormGuardPanel({ guard }: { guard: PaymentFormGuard }) {
  if (guard === 'loading_config') {
    return (
      <div className="bg-white rounded-xl shadow-md border border-gray-200 p-4 sm:p-6 md:p-8">
        <div className="text-center py-12">
          <p className="text-gray-600">Loading payment configuration...</p>
        </div>
      </div>
    )
  }

  if (guard === 'loading_application') {
    return (
      <div className="bg-white rounded-xl shadow-md border border-gray-200 p-4 sm:p-6 md:p-8">
        <div className="text-center py-12">
          <p className="text-gray-600">{APPLICANT_CONTENT.application.messages.loading}</p>
        </div>
      </div>
    )
  }

  if (guard === 'no_application_fee') {
    return (
      <div className="bg-white rounded-xl shadow-md border border-red-200 p-4 sm:p-6 md:p-8">
        <div className="text-center py-12">
          <p className="text-red-600 font-semibold mb-2">Application Fee Not Available</p>
          <p className="text-gray-600 text-sm">
            The application fee information is missing. Please refresh the page or contact support.
          </p>
        </div>
      </div>
    )
  }

  if (guard === 'no_remaining') {
    return (
      <div className="bg-white rounded-xl shadow-md border border-green-200 p-4 sm:p-6 md:p-8">
        <div className="text-center py-12">
          <p className="text-green-600 font-semibold mb-2">No Payment Due</p>
          <p className="text-gray-600 text-sm">There is no remaining balance to pay.</p>
        </div>
      </div>
    )
  }

  if (guard === 'no_methods') {
    return (
      <div className="bg-white rounded-xl shadow-md border border-red-200 p-4 sm:p-6 md:p-8">
        <div className="text-center py-12">
          <p className="text-red-600 font-semibold">No payment methods available</p>
          <p className="text-gray-600 text-sm mt-2">Please contact support.</p>
        </div>
      </div>
    )
  }

  return null
}
